import { supabase } from "@/lib/supabase";

/** Returns true when at least one administrator account already exists. */
export async function existeAdmin(): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc("existe_admin");
    if (error) return false;
    return Boolean(data);
  } catch {
    return false;
  }
}

/**
 * Confirms the signed-in user is an active administrator.
 * If no administrator exists yet and a session is present, claims the first admin
 * account (first-run bootstrap) so the owner is never locked out.
 */
export async function verificarAccesoAdmin(
  nombre?: string,
  email?: string,
): Promise<boolean> {
  try {
    const { data: isAdmin } = await supabase.rpc("es_admin");
    if (isAdmin) return true;

    const { data: claimed } = await supabase.rpc("reclamar_admin", {
      p_nombre: nombre?.trim() || null,
      p_email: email?.trim() || null,
    });
    return Boolean(claimed);
  } catch {
    return false;
  }
}